import { ReactComponent as AllM } from './M/all-m.svg';
import { ReactComponent as AllS } from './S/all-s.svg';
import { ReactComponent as ArrowDownM } from './M/arrow-down-m.svg';
import { ReactComponent as ArrowDownS } from './S/arrow-down-s.svg';
import { ReactComponent as ArrowLeftM } from './M/arrow-left-m.svg';
import { ReactComponent as ArrowLeftS } from './S/arrow-left-s.svg';
import { ReactComponent as ArrowRightM } from './M/arrow-right-m.svg';
import { ReactComponent as ArrowRightS } from './S/arrow-right-s.svg';
import { ReactComponent as ArrowUpM } from './M/arrow-up-m.svg';
import { ReactComponent as ArrowUpS } from './S/arrow-up-s.svg';
import { ReactComponent as AvatarM } from './M/avatar-m.svg';
import { ReactComponent as AvatarS } from './S/avatar-s.svg';
import { ReactComponent as BurnM } from './M/burn-m.svg';
import { ReactComponent as BurnS } from './S/burn-s.svg';
import { ReactComponent as CalendarM } from './M/calendar-m.svg';
import { ReactComponent as CalendarS } from './S/calendar-s.svg';
import { ReactComponent as CancelM } from './M/cancel-m.svg';
import { ReactComponent as CancelS } from './S/cancel-s.svg';
import { ReactComponent as ChampionM } from './M/champion-m.svg';
import { ReactComponent as ChampionS } from './S/champion-s.svg';
import { ReactComponent as CheckM } from './M/check-m.svg';
import { ReactComponent as CheckS } from './S/check-s.svg';
import { ReactComponent as CheckBoxM } from './M/check-box-m.svg';
import { ReactComponent as CheckBoxS } from './S/check-box-s.svg';
import { ReactComponent as CheckBoxCheckedM } from './M/check-box-checked-m.svg';
import { ReactComponent as CheckBoxCheckedS } from './S/check-box-checked-s.svg';
import { ReactComponent as CircleM } from './M/circle-m.svg';
import { ReactComponent as CircleS } from './S/circle-s.svg';
import { ReactComponent as ClockM } from './M/clock-m.svg';
import { ReactComponent as ClockS } from './S/clock-s.svg';
import { ReactComponent as CloseM } from './M/close-m.svg';
import { ReactComponent as CloseS } from './S/close-s.svg';
import { ReactComponent as CopyM } from './M/copy-m.svg';
import { ReactComponent as CopyS } from './S/copy-s.svg';
import { ReactComponent as CreateM } from './M/create-m.svg';
import { ReactComponent as CreateS } from './S/create-s.svg';
import { ReactComponent as DiceM } from './M/dice-m.svg';
import { ReactComponent as DiceS } from './S/dice-s.svg';
import { ReactComponent as DiscordM } from './M/discord-m.svg';
import { ReactComponent as DiscordS } from './S/discord-s.svg';
import { ReactComponent as DollarM } from './M/dollar-m.svg';
import { ReactComponent as DollarS } from './S/dollar-s.svg';
import { ReactComponent as DoneM } from './M/done-m.svg';
import { ReactComponent as DoneS } from './S/done-s.svg';
import { ReactComponent as DownloadM } from './M/download-m.svg';
import { ReactComponent as DownloadS } from './S/download-s.svg';
import { ReactComponent as EditM } from './M/edit-m.svg';
import { ReactComponent as EditS } from './S/edit-s.svg';
import { ReactComponent as ExpiredM } from './M/expired-m.svg';
import { ReactComponent as ExpiredS } from './S/expired-s.svg';
import { ReactComponent as ExternalLinkM } from './M/external-link-m.svg';
import { ReactComponent as ExternalLinkS } from './S/external-link-s.svg';
import { ReactComponent as FileM } from './M/file-m.svg';
import { ReactComponent as FileS } from './S/file-s.svg';
import { ReactComponent as FiltersM } from './M/filters-m.svg';
import { ReactComponent as FiltersS } from './S/filters-s.svg';
import { ReactComponent as GasM } from './M/gas-m.svg';
import { ReactComponent as GasS } from './S/gas-s.svg';
import { ReactComponent as GiftM } from './M/gift-m.svg';
import { ReactComponent as GiftS } from './S/gift-s.svg';
import { ReactComponent as GridM } from './M/grid-m.svg';
import { ReactComponent as GridS } from './S/grid-s.svg';
import { ReactComponent as HappyM } from './M/happy-m.svg';
import { ReactComponent as HappyS } from './S/happy-s.svg';
import { ReactComponent as HeartM } from './M/heart-m.svg';
import { ReactComponent as HeartS } from './S/heart-s.svg';
import { ReactComponent as HelpM } from './M/help-m.svg';
import { ReactComponent as HelpS } from './S/help-s.svg';
import { ReactComponent as HomeM } from './M/home-m.svg';
import { ReactComponent as HomeS } from './S/home-s.svg';
import { ReactComponent as InfoM } from './M/info-m.svg';
import { ReactComponent as InfoS } from './S/info-s.svg';
import { ReactComponent as KeyM } from './M/key-m.svg';
import { ReactComponent as KeyS } from './S/key-s.svg';
import { ReactComponent as LeaderboardM } from './M/leaderboard-m.svg';
import { ReactComponent as LeaderboardS } from './S/leaderboard-s.svg';
import { ReactComponent as ListM } from './M/list-m.svg';
import { ReactComponent as ListS } from './S/list-s.svg';
import { ReactComponent as LiveM } from './M/live-m.svg';
import { ReactComponent as LiveS } from './S/live-s.svg';
import { ReactComponent as LockM } from './M/lock-m.svg';
import { ReactComponent as LockS } from './S/lock-s.svg';
import { ReactComponent as LoginM } from './M/login-m.svg';
import { ReactComponent as LoginS } from './S/login-s.svg';
import { ReactComponent as LogoutM } from './M/logout-m.svg';
import { ReactComponent as LogoutS } from './S/logout-s.svg';
import { ReactComponent as MeM } from './M/ME-m.svg';
import { ReactComponent as MeS } from './S/ME-s.svg';
import { ReactComponent as MenuM } from './M/menu-m.svg';
import { ReactComponent as MenuS } from './S/menu-s.svg';
import { ReactComponent as MinusM } from './M/minus-m.svg';
import { ReactComponent as MinusS } from './S/minus-s.svg';
import { ReactComponent as MoonM } from './M/moon-m.svg';
import { ReactComponent as MoonS } from './S/moon-s.svg';
import { ReactComponent as NotificationM } from './M/notification-m.svg';
import { ReactComponent as NotificationS } from './S/notification-s.svg';
import { ReactComponent as PlusM } from './M/plus-m.svg';
import { ReactComponent as PlusS } from './S/plus-s.svg';
import { ReactComponent as PoolM } from './M/pool-m.svg';
import { ReactComponent as PoolS } from './S/pool-s.svg';
import { ReactComponent as ReloadM } from './M/reload-m.svg';
import { ReactComponent as ReloadS } from './S/reload-s.svg';
import { ReactComponent as ReportM } from './M/report-m.svg';
import { ReactComponent as ReportS } from './S/report-s.svg';
import { ReactComponent as RocketM } from './M/rocket-m.svg';
import { ReactComponent as RocketS } from './S/rocket-s.svg';
import { ReactComponent as SaS } from './S/sa-s.svg';
import { ReactComponent as SadM } from './M/sad-m.svg';
import { ReactComponent as SearchM } from './M/search-m.svg';
import { ReactComponent as SearchS } from './S/search-s.svg';
import { ReactComponent as SettingsM } from './M/settings-m.svg';
import { ReactComponent as SettingsS } from './S/settings-s.svg';
import { ReactComponent as ShareM } from './M/share-m.svg';
import { ReactComponent as ShareS } from './S/share-s.svg';
import { ReactComponent as ShoppingM } from './M/shopping-m.svg';
import { ReactComponent as ShoppingS } from './S/shopping-s.svg';
import { ReactComponent as ShoppingAddM } from './M/shopping-add-m.svg';
import { ReactComponent as ShoppingAddS } from './S/shopping-add-s.svg';
import { ReactComponent as SoonM } from './M/soon-m.svg';
import { ReactComponent as SoonS } from './S/soon-s.svg';
import { ReactComponent as SortingM } from './M/sorting-m.svg';
import { ReactComponent as SortingS } from './S/sorting-s.svg';
import { ReactComponent as StarM } from './M/star-m.svg';
import { ReactComponent as StarS } from './S/star-s.svg';
import { ReactComponent as SunM } from './M/sun-m.svg';
import { ReactComponent as SunS } from './S/sun-s.svg';
import { ReactComponent as SupportM } from './M/support-m.svg';
import { ReactComponent as SupportS } from './S/support-s.svg';
import { ReactComponent as SwapM } from './M/swap-m.svg';
import { ReactComponent as SwapS } from './S/swap-s.svg';
import { ReactComponent as TelegramM } from './M/telegram-m.svg';
import { ReactComponent as TelegramS } from './S/telegram-s.svg';
import { ReactComponent as TermsM } from './M/terms-m.svg';
import { ReactComponent as TermsS } from './S/terms-s.svg';
import { ReactComponent as TicketM } from './M/ticket-m.svg';
import { ReactComponent as TicketS } from './S/ticket-s.svg';
import { ReactComponent as TransactionM } from './M/transaction-m.svg';
import { ReactComponent as TransactionS } from './S/transaction-s.svg';
import { ReactComponent as TrashM } from './M/trash-m.svg';
import { ReactComponent as TrashS } from './S/trash-s.svg';
import { ReactComponent as TrianglesM } from './M/triangles-m.svg';
import { ReactComponent as TrianglesS } from './S/triangles-s.svg';
import { ReactComponent as TrianglesDownM } from './M/triangles-down-m.svg';
import { ReactComponent as TrianglesDownS } from './S/triangles-down-s.svg';
import { ReactComponent as TrianglesUpM } from './M/triangles-up-m.svg';
import { ReactComponent as TrianglesUpS } from './S/triangles-up-s.svg';
import { ReactComponent as TwitterM } from './M/twitter-m.svg';
import { ReactComponent as TwitterS } from './S/twitter-s.svg';
import { ReactComponent as UnlockM } from './M/unlock-m.svg';
import { ReactComponent as UnlockS } from './S/unlock-s.svg';
import { ReactComponent as UploadM } from './M/upload-m.svg';
import { ReactComponent as UploadS } from './S/upload-s.svg';
import { ReactComponent as UserM } from './M/user-m.svg';
import { ReactComponent as UserS } from './S/user-s.svg';
import { ReactComponent as UsersM } from './M/users-m.svg';
import { ReactComponent as UsersS } from './S/users-s.svg';
import { ReactComponent as VerifiedM } from './M/verified-m.svg';
import { ReactComponent as VerifiedS } from './S/verified-s.svg';
import { ReactComponent as VisibilityM } from './M/visibility-m.svg';
import { ReactComponent as VisibilityS } from './S/visibility-s.svg';
import { ReactComponent as VisibilityOffM } from './M/visibility-off-m.svg';
import { ReactComponent as VisibilityOffS } from './S/visibility-off-s.svg';
import { ReactComponent as WalletM } from './M/wallet-m.svg';
import { ReactComponent as WalletS } from './S/wallet-s.svg';
import { ReactComponent as WebM } from './M/web-m.svg';
import { ReactComponent as WebS } from './S/web-s.svg';
import { ReactComponent as BitcoinM } from './M/bitcoin-m.svg';
import { ReactComponent as BitcoinS } from './S/bitcoin-s.svg';
import { ReactComponent as ProgressS } from './S/progress-s.svg';
import { ReactComponent as AppLogoM } from './M/app-logo-m.svg';
import { ReactComponent as AppLogoL } from './L/app-logo-l.svg';

interface IconSvgProps {
  icon: Icons;
  className?: string;
  [key: string]: any;
}

const icons = Object.freeze({
  allM: AllM,
  allS: AllS,
  arrowDownM: ArrowDownM,
  arrowDownS: ArrowDownS,
  arrowLeftM: ArrowLeftM,
  arrowLeftS: ArrowLeftS,
  arrowRightM: ArrowRightM,
  arrowRightS: ArrowRightS,
  arrowUpM: ArrowUpM,
  arrowUpS: ArrowUpS,
  avatarM: AvatarM,
  avatarS: AvatarS,
  burnM: BurnM,
  burnS: BurnS,
  calendarM: CalendarM,
  calendarS: CalendarS,
  cancelM: CancelM,
  cancelS: CancelS,
  championM: ChampionM,
  championS: ChampionS,
  checkM: CheckM,
  checkS: CheckS,
  checkBoxM: CheckBoxM,
  checkBoxS: CheckBoxS,
  checkBoxCheckedM: CheckBoxCheckedM,
  checkBoxCheckedS: CheckBoxCheckedS,
  circleM: CircleM,
  circleS: CircleS,
  clockM: ClockM,
  clockS: ClockS,
  closeM: CloseM,
  closeS: CloseS,
  copyM: CopyM,
  copyS: CopyS,
  createM: CreateM,
  createS: CreateS,
  diceM: DiceM,
  diceS: DiceS,
  discordM: DiscordM,
  discordS: DiscordS,
  dollarM: DollarM,
  dollarS: DollarS,
  doneM: DoneM,
  doneS: DoneS,
  downloadM: DownloadM,
  downloadS: DownloadS,
  editM: EditM,
  editS: EditS,
  expiredM: ExpiredM,
  expiredS: ExpiredS,
  externalLinkM: ExternalLinkM,
  externalLinkS: ExternalLinkS,
  fileM: FileM,
  fileS: FileS,
  filtersM: FiltersM,
  filtersS: FiltersS,
  gasM: GasM,
  gasS: GasS,
  giftM: GiftM,
  giftS: GiftS,
  gridM: GridM,
  gridS: GridS,
  happyM: HappyM,
  happyS: HappyS,
  heartM: HeartM,
  heartS: HeartS,
  helpM: HelpM,
  helpS: HelpS,
  homeM: HomeM,
  homeS: HomeS,
  infoM: InfoM,
  infoS: InfoS,
  keyM: KeyM,
  keyS: KeyS,
  leaderboardM: LeaderboardM,
  leaderboardS: LeaderboardS,
  listM: ListM,
  listS: ListS,
  liveM: LiveM,
  liveS: LiveS,
  lockM: LockM,
  lockS: LockS,
  loginM: LoginM,
  loginS: LoginS,
  logoutM: LogoutM,
  logoutS: LogoutS,
  meM: MeM,
  meS: MeS,
  menuM: MenuM,
  menuS: MenuS,
  minusM: MinusM,
  minusS: MinusS,
  moonM: MoonM,
  moonS: MoonS,
  notificationM: NotificationM,
  notificationS: NotificationS,
  plusM: PlusM,
  plusS: PlusS,
  poolM: PoolM,
  poolS: PoolS,
  reloadM: ReloadM,
  reloadS: ReloadS,
  reportM: ReportM,
  reportS: ReportS,
  rocketM: RocketM,
  rocketS: RocketS,
  saS: SaS,
  sadM: SadM,
  searchM: SearchM,
  searchS: SearchS,
  settingsM: SettingsM,
  settingsS: SettingsS,
  shareM: ShareM,
  shareS: ShareS,
  shoppingM: ShoppingM,
  shoppingS: ShoppingS,
  shoppingAddM: ShoppingAddM,
  shoppingAddS: ShoppingAddS,
  soonM: SoonM,
  soonS: SoonS,
  sortingM: SortingM,
  sortingS: SortingS,
  starM: StarM,
  starS: StarS,
  sunM: SunM,
  sunS: SunS,
  supportM: SupportM,
  supportS: SupportS,
  swapM: SwapM,
  swapS: SwapS,
  telegramM: TelegramM,
  telegramS: TelegramS,
  termsM: TermsM,
  termsS: TermsS,
  ticketM: TicketM,
  ticketS: TicketS,
  transactionM: TransactionM,
  transactionS: TransactionS,
  trashM: TrashM,
  trashS: TrashS,
  trianglesM: TrianglesM,
  trianglesS: TrianglesS,
  trianglesDownM: TrianglesDownM,
  trianglesDownS: TrianglesDownS,
  trianglesUpM: TrianglesUpM,
  trianglesUpS: TrianglesUpS,
  twitterM: TwitterM,
  twitterS: TwitterS,
  unlockM: UnlockM,
  unlockS: UnlockS,
  uploadM: UploadM,
  uploadS: UploadS,
  userM: UserM,
  userS: UserS,
  usersM: UsersM,
  usersS: UsersS,
  verifiedM: VerifiedM,
  verifiedS: VerifiedS,
  visibilityM: VisibilityM,
  visibilityS: VisibilityS,
  visibilityOffM: VisibilityOffM,
  visibilityOffS: VisibilityOffS,
  walletM: WalletM,
  walletS: WalletS,
  webM: WebM,
  webS: WebS,
  bitcoinM: BitcoinM,
  bitcoinS: BitcoinS,
  progressS: ProgressS,
  appLogoM: AppLogoM,
  appLogoL: AppLogoL,
});

export type Icons = keyof typeof icons;

const IconSvg = ({ icon, className, ...rest }: IconSvgProps) => {
  const SvgIcon = icons[icon];
  return <SvgIcon className={`flex-shrink-0 ${className}`} {...rest} />;
};

export default IconSvg;
